import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import AccessHistoryService from "services/AccessHistoryService";

export const searchAccessHistoryApi = createAsyncThunk(
  "accessHistory/search",
  async (params, { rejectWithValue }) => {
    try {
      const response = await AccessHistoryService.search(params);

      // FetchInterceptor has already unwrapped the HTTP response. Keep the
      // API pagination object intact so its field names are consumed as sent.
      return response.data;
    } catch (err) {
      return rejectWithValue(err.response?.data || err.message || "Error");
    }
  },
);

const initialState = {
  loading: false,
  result: {
    pageIndex: 1,
    totalPages: 0,
    totalItems: 0,
    pageSize: 10,
    items: [],
    totalTotalOrderPayment: 0,
    hasPreviousPage: false,
    hasNextPage: false,
  },
  error: null,
};

const accessHistorySlice = createSlice({
  name: "accessHistory",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(searchAccessHistoryApi.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(searchAccessHistoryApi.fulfilled, (state, action) => {
        state.loading = false;
        state.result = action.payload;
      })
      .addCase(searchAccessHistoryApi.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export default accessHistorySlice.reducer;
